import api from "./api";

export const createThreadReply = async (data) => {
  const response = await api.post("/threads/reply", data);
  return response.data;
};

export const getThreadReplies = async (
  parentMessageId,
  page = 1,
  limit = 50,
) => {
  const response = await api.get(
    `/threads/${parentMessageId}?page=${page}&limit=${limit}`,
  );
  return response.data;
};

export const updateThreadReply = async (replyId, content) => {
  const response = await api.put(`/threads/${replyId}`, { content });
  return response.data;
};

export const deleteThreadReply = async (replyId) => {
  const response = await api.delete(`/threads/${replyId}`);
  return response.data;
};

export const markThreadAsRead = async (parentMessageId, chatType) => {
  const response = await api.post(`/threads/${parentMessageId}/read`, {
    chatType,
  });
  return response.data;
};

export const getThreadParticipants = async (parentMessageId) => {
  const response = await api.get(`/threads/${parentMessageId}/participants`);
  return response.data;
};

export const getThreadUnreadCount = async (chatId, lastReadAt) => {
  const response = await api.get(
    `/threads/count/${chatId}${lastReadAt ? `?lastReadAt=${lastReadAt}` : ""}`,
  );
  return response.data;
};

export const getUserThreads = async (userId) => {
  const response = await api.get(`/threads/user/${userId}`);
  return response.data;
};
